import React from 'react';
import { Alert, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useInterventionCreation } from '../../context/interventionCreationContext';

/**
 * Bilan de la dernière suppression unitaire, affiché au-dessus de la table comme les
 * autres bilans de l'écran.
 *
 * Supprimer une ligne se fait d'un seul clic, sans confirmation : sans ce bandeau,
 * rien ne distingue une suppression réussie d'un clic resté sans effet.
 */
export default function DeletionReportBanner() {
  const { t } = useTranslation();
  const { state, dispatch } = useInterventionCreation();

  const report = state.lastDeletionReport;

  if (report === null) {
    return null;
  }

  return (
    <Alert
      severity="success"
      closeText={t('close')}
      onClose={() => dispatch({ type: 'dismissDeletionReport' })}
    >
      <Typography variant="body2">
        {t('interventionCreation.requests.deletionReport', { count: report.deletedCount })}
      </Typography>
    </Alert>
  );
}
